// extracted by mini-css-extract-plugin
export default {"list":"styles_list__rMNPD","filters":"styles_filters__ss8O7"};